export const GAMES = 'responsivegames';

export const CATEGORY_TYPE = {
    RECENTLY: 'recentlyplayed',
    FAVORITES: 'favorites',
    PINNED: 'pinned',
    TAB: 'tab'
};

export const FEATURES_TYPES = ['fsb', 'goldenChips', 'wilds'];

export const VOLATILITY = ['very-low', 'low', 'medium', 'high'];
